export default "__VITE_ASSET__TiWhQ6IO__"